/** 
 * @type {import("./defs").StorePlanFile} 
 */
const store = {
}
/** 
* @returns {import("./defs").StorePlanFile} 
*/
export default function () {
    return JSON.parse(JSON.stringify(store));
}


// WEBPACK FOOTER //
// ./resources/js/storers/StorePlanFile.js